import { render } from "./shopify.vue?vue&type=template&id=9a290472&scoped=true"
import script from "./shopify.vue?vue&type=script&lang=js"
export * from "./shopify.vue?vue&type=script&lang=js"

import "./shopify.vue?vue&type=style&index=0&id=9a290472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a290472"]])

export default __exports__